// extracted by mini-css-extract-plugin
export default {"base":"base--1vB1A","bodyWrap":"bodyWrap--1vB1A","body":"body--1vB1A","img":"img--1vB1A","heading":"heading--1vB1A"};